import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-terms',
  imports: [
    RouterLink
  ],
  templateUrl: './terms.html',
  styleUrl: './terms.scss'
})
export class Terms {

}
